import styled from "styled-components";

export const NumericInputContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const Input = styled.input`
  width: 40px;
  height: 50px;
  text-align: center;
  font-size: 1.5rem;
  border-radius: 8px;
  border: 1px solid #ccc;

  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;
